import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.css']
})
export class TitleComponent implements OnInit {
  @Input() title = 'Component title';
  @Input() countValue;
  @Input() changeColorBasedOnCount = true;

  constructor() { }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /app/src/app/shared/title/title.component.ts